module.exports = __webpack_public_path__ + "img/015_thumbnail.d62ca854.jpg";